import { render } from "./taxNeimengSl.vue?vue&type=template&id=9b180fb4&scoped=true"
import script from "./taxNeimengSl.vue?vue&type=script&lang=js"
export * from "./taxNeimengSl.vue?vue&type=script&lang=js"

import "./taxNeimengSl.vue?vue&type=style&index=0&id=9b180fb4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b180fb4"]])

export default __exports__